import type { FaireProductEntity } from "../../entity_types/product";

export const p_xbn7tgxn7e: FaireProductEntity = {
  token: "p_xbn7tgxn7e",
  type: "product",
  name: "Body Cupping Kit - Wellness Recovery",
  brandToken: "b_a03hpip0sg",
  brandName: "WTHN",
  imageUrl: "https://cdn.faire.com/fastly/043617aec749072da1a698dce63dfb0d5d1768d192af8d0bbf83f44bb3c7c74e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e7455a0b40417a5d88898b231ea229e19dd0ba5c7f9b23a852cc8db98678b667.jpeg",
    "https://cdn.faire.com/fastly/43653329da29352eadf3b43f5271fc0f4e70fe41a0fb2b505f3f69c55749e913.jpeg",
    "https://cdn.faire.com/fastly/fd235e6e9f2a25f6e9b6f9343fe476fa325fd262367e7b2d6c52edc9c98f16b4.jpeg",
    "https://cdn.faire.com/fastly/83cee7f11c05d495a2d0d205028e6d567d76ebc1448dd7901fd35051bd84ef02.jpeg",
    "https://cdn.faire.com/fastly/d86812c277a711054cf4dbeb215ac8b940510fbcdce27d6485ba96e4ab025c20.jpeg"
  ],
  priceDollars: 36,
  description: "Sit back and relax. Body cupping is used in Traditional Chinese Medicine to reduce tension, increase circulation, and support detox. Suction from the cups gently lifts tissue up for a release.\n\nEach kit includes:\n\n8 silicone cups\nA traveling case \nDetailed how-to guide",
  tags: [],
  msrpDollars: 68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:11.673Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
